module.exports = __webpack_public_path__ + "media/npc_dota_hero_queenofpain.e61d5da5.webm";